"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_window_1 = require("react-window");
var OptimizedMenuList = /** @class */ (function (_super) {
    __extends(OptimizedMenuList, _super);
    function OptimizedMenuList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.height = 40;
        return _this;
    }
    OptimizedMenuList.prototype.render = function () {
        var _a = this.props, options = _a.options, children = _a.children, maxHeight = _a.maxHeight, getValue = _a.getValue, selectProps = _a.selectProps;
        var selectedValues = getValue();
        var initialOffset = selectedValues && selectedValues[0] ? options.indexOf(selectedValues[0]) * this.height : 0;
        var showErrorMessage = React.Children.count(children) === 1 && children[0] === undefined;
        return (React.createElement(React.Fragment, null,
            React.createElement(react_window_1.FixedSizeList, { height: showErrorMessage ? 0 : maxHeight, itemCount: children["length"], itemSize: showErrorMessage ? 0 : this.height, initialScrollOffset: initialOffset, width: "" }, function (_a) {
                var index = _a.index, style = _a.style;
                return React.createElement("div", { className: "option-wrapper", style: style }, children[index]);
            }),
            showErrorMessage && React.createElement("div", null,
                React.createElement("div", { className: "text-red pl-4 pr-4 pb-2 pt-3" },
                    "Sorry, we couldn't find any matches for \"",
                    selectProps.inputValue,
                    "\""),
                selectProps.helpTextRow1 && React.createElement("div", { className: "pl-4 pr-4 pt-3 pb-2 help-text" }, selectProps.helpTextRow1),
                selectProps.helpTextRow2 && React.createElement("div", { className: "pl-4 pr-4 pt-2 pb-3 help-text" }, selectProps.helpTextRow2))));
    };
    return OptimizedMenuList;
}(React.Component));
exports.default = OptimizedMenuList;
//# sourceMappingURL=OptimizedMenuList.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/OptimizedMenuList.js
// module id = 3635
// module chunks = 0